/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for user guide.
 * @export
 * @interface UserGuide
 */
export interface UserGuide {
    /**
     * 
     * @type {number}
     * @memberof UserGuide
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof UserGuide
     */
    file: string;
    /**
     * 
     * @type {Date}
     * @memberof UserGuide
     */
    readonly createdAt: Date | null;
}

/**
 * Check if a given object implements the UserGuide interface.
 */
export function instanceOfUserGuide(value: object): value is UserGuide {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('file' in value) || value['file'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    return true;
}

export function UserGuideFromJSON(json: any): UserGuide {
    return UserGuideFromJSONTyped(json, false);
}

export function UserGuideFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGuide {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'file': json['file'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
    };
}

export function UserGuideToJSON(json: any): UserGuide {
    return UserGuideToJSONTyped(json, false);
}

export function UserGuideToJSONTyped(value?: Omit<UserGuide, 'id'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file': value['file'],
    };
}

